import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import { Card } from "@material-ui/core";

export default function ListingClicksByUsers() {

    const [labels, setLabels] = useState([]);
    const [data, setData] = useState([]);
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "success",
        message: "",
    });

    useEffect(() => {
        loadData()
    }, []);

    const loadData = async () => {
        try {
            const { data } = await axios.get("/listing/clicks/listingClickByUsers");
            setLabels(data?.listings);
            setData(data?.count);
        } catch (error) {
            setAlert({
                showAlert: true,
                severity: "error",
                message: "Data loading failed!",
            });
        }
    };

    const chartDetails = {
        maintainAspectRatio: false,
        responsive: true,
        labels: labels,
        datasets: [
            {
                label: "Listing Clicks",
                data: data,
                backgroundColor: [
                    "#50AF95",
                ]
            }
        ]
    }
    const styles = {
        barContainer: {
            position: "relative"
        }
    };

    return (
        <Card>
            <div style={styles.barContainer}>
                <Bar
                    data={chartDetails}
                    width={'50%'}
                    height={'30%'}
                    fontSize='2px'
                    options={{
                        plugins: {
                            title: {
                                display: true,
                                text: "Listing Clicks"
                            },
                            legend: {
                                display: true,
                                position: "bottom"
                            }
                        }
                    }}
                />
            </div>
        </Card>
    );
}